const translations = {
  common: {
    logo: "KOON-SERVICE",
    viewService: "查看服务",
    explore: "探索服务",
    contactHelp: "联系我们获取支持",
    contactButton: "联系我们",
    footer: "© 2026 Koon-Service. All rights reserved. พัฒนาโดย นักศึกษาสาขาเทคโนโลยีดิจิทัลและสารสนเทศ ระดับปริญญาตรี",
    phone: "电话: 062-428-3696",
    line: "Line: @koon_s",
    email: "电子邮件: kvs_service@koonservice.com",
    hours: "每天 : 8:00 - 17:00",
  },

  nav: {
    home: "首页",
    services: "服务",
    about: "关于我们",
    contact: "联系我们",
  },

  language: {
    th: "TH 🇹🇭",
    en: "EN 🇺🇸",
    lo: "LA 🇱🇦",
    mm: "MM 🇲🇲",
    zh: "中文 🇨🇳",
  },

  hero: {
    subtitle: "为您的企业提供专业 IT 解决方案",
    cta: "探索公司",
  },

  home: {
    servicesTitle: "我们的服务",
    whyTitle: "为什么选择我们",

    why: [
      {
        title: "快速",
        desc: "我们提供快速服务，减少系统停机时间，让您的业务持续运行。",
      },

      {
        title: "专业",
        desc: "我们的团队拥有超过5年的 IT 经验，并能高效解决问题。",
      },

      {
        title: "高质量",
        desc: "我们遵循国际标准，确保您的系统稳定、安全并可靠运行。",
      },
    ],

    contactTitle: "联系方式",

    address1:
      "Koon Service 有限公司\n329 Moo 10 Bang Sao Thong\nSamut Prakan 10570",

    address2:
      "Koon Service 有限公司\n18 Lasalle 65 Bangna\nBangkok 10260",
  },

  services: {
    itService: "IT 服务",
    cctv: "监控与安全",
    equipment: "IT 设备",
    network: "网络与安全",
  },

  itService: {
    title: "IT 服务",
    introTitle: "企业 IT 服务",

    introText:
      "我们提供专业 IT 外包工程师，负责安装、维护及故障排除。",

    detailTitle: "服务范围",

    pointsLeft: [
      "安装计算机与网络系统",
      "检查并修复硬件/软件问题",
      "维护服务器与内部系统",
      "用户支持 (Helpdesk)",
      "设置 WiFi 与 LAN",
    ],

    pointsRight: [
      "IT 系统维护",
      "安全与防火墙管理",
      "数据备份",
      "24/7 系统监控",
      "IT 咨询服务",
    ],

    problemsTitle: "如果您遇到这些问题",

    ctaContact: "联系我们获取支持",
  },
};
export default translations;